import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { BiData, OpenPromptModalBiEvent } from '@wix/da-bi/pkg/events';
import {
  getActiveSection,
  getPlaygroundSubsection,
} from '../../../selectors/studio';
import { StudioSection, PlaygroundSubsection } from '../../../types/store';

export function useDreamupEditAction(deviation: PapiDeviation) {
  const { t } = useTranslation();
  const activeSection = useSelector(getActiveSection);
  const activePlaygroundSection = useSelector(getPlaygroundSubsection);

  return (
    activeSection === StudioSection.PLAYGROUND &&
    activePlaygroundSection === PlaygroundSubsection.DreamUp &&
    !!deviation.stashPrivateid && {
      label: t('studio.table.actions.dreamupEdit'),
      link: Url.dreamupLink({ stashId: deviation.stashPrivateid }),
      target: '_blank',
      biData: BiData<OpenPromptModalBiEvent>({
        evid: 921,
        deviationid: deviation.deviationId,
      }),
    }
  );
}
